/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SaveAssetSelfEmploymentRequest } from './SaveAssetSelfEmploymentRequest';
import {
    SaveAssetSelfEmploymentRequestFromJSON,
    SaveAssetSelfEmploymentRequestFromJSONTyped,
    SaveAssetSelfEmploymentRequestToJSON,
    SaveAssetSelfEmploymentRequestToJSONTyped,
} from './SaveAssetSelfEmploymentRequest';
import type { AssetIncomeRequest } from './AssetIncomeRequest';
import {
    AssetIncomeRequestFromJSON,
    AssetIncomeRequestFromJSONTyped,
    AssetIncomeRequestToJSON,
    AssetIncomeRequestToJSONTyped,
} from './AssetIncomeRequest';

/**
 * 
 * @export
 * @interface SaveAssetIncomeRequest
 */
export interface SaveAssetIncomeRequest {
    /**
     * 
     * @type {SaveAssetSelfEmploymentRequest}
     * @memberof SaveAssetIncomeRequest
     */
    selfEmployment: SaveAssetSelfEmploymentRequest;
    /**
     * 
     * @type {Array<AssetIncomeRequest>}
     * @memberof SaveAssetIncomeRequest
     */
    incomes: Array<AssetIncomeRequest>;
}

/**
 * Check if a given object implements the SaveAssetIncomeRequest interface.
 */
export function instanceOfSaveAssetIncomeRequest(value: object): value is SaveAssetIncomeRequest {
    if (!('selfEmployment' in value) || value['selfEmployment'] === undefined) return false;
    if (!('incomes' in value) || value['incomes'] === undefined) return false;
    return true;
}

export function SaveAssetIncomeRequestFromJSON(json: any): SaveAssetIncomeRequest {
    return SaveAssetIncomeRequestFromJSONTyped(json, false);
}

export function SaveAssetIncomeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetIncomeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selfEmployment': SaveAssetSelfEmploymentRequestFromJSON(json['selfEmployment']),
        'incomes': ((json['incomes'] as Array<any>).map(AssetIncomeRequestFromJSON)),
    };
}

export function SaveAssetIncomeRequestToJSON(json: any): SaveAssetIncomeRequest {
    return SaveAssetIncomeRequestToJSONTyped(json, false);
}

export function SaveAssetIncomeRequestToJSONTyped(value?: SaveAssetIncomeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selfEmployment': SaveAssetSelfEmploymentRequestToJSON(value['selfEmployment']),
        'incomes': ((value['incomes'] as Array<any>).map(AssetIncomeRequestToJSON)),
    };
}

